import { getApiOrigin } from '../apiBase';

/** Полный URL аватара школы по пути из API (/uploads/school-logos/3.jpg). */
export function getSchoolLogoUrl(logoPath, cacheBust) {
    if (!logoPath || typeof logoPath !== 'string') return null;
    const trimmed = logoPath.trim();
    if (trimmed.startsWith('blob:')) return trimmed;
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
        if (cacheBust != null) {
            const sep = trimmed.includes('?') ? '&' : '?';
            return `${trimmed}${sep}v=${cacheBust}`;
        }
        return trimmed;
    }
    const origin = getApiOrigin();
    const base = `${origin}${trimmed.startsWith('/') ? trimmed : `/${trimmed}`}`;
    if (cacheBust != null) {
        return `${base}${base.includes('?') ? '&' : '?'}v=${cacheBust}`;
    }
    return base;
}
